/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Fix: "Heure" (alternate-font text-highlight) sometimes stays invisible on the slideshow.
  // Root cause: AOS triggers shouldAnimate() before Flickity adds .is-selected to the first slide,
  // so the animation never fires. This watches for Flickity init and re-triggers the animation.
  function fixSlideshowHighlights(slideshow) {
    function tryFix() {
      var activeSlide = slideshow.querySelector('[data-slide].is-selected');
      if (!activeSlide) return;
      activeSlide.querySelectorAll('text-highlight[data-highlight-type="alternate-font"]').forEach(function(el) {
        if (el.getAttribute('data-is-active') !== 'true') {
          el.shouldAnimate && el.shouldAnimate();
        }
      });
    }
    if (slideshow.classList.contains('flickity-enabled')) {
      requestAnimationFrame(tryFix);
    } else {
      var obs = new MutationObserver(function(_, o) {
        if (slideshow.classList.contains('flickity-enabled')) {
          o.disconnect();
          requestAnimationFrame(tryFix);
        }
      });
      obs.observe(slideshow, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function initSlideshowFix() {
    document.querySelectorAll('slideshow-component').forEach(fixSlideshowHighlights);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshowFix);
  } else {
    initSlideshowFix();
  }





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
